import i18next from 'i18next';
import { Condition } from '../@types/Condition';
import { Valuation } from '../@types/Valuation';
import { sendRequest } from './http';
import { MarketCode } from '../@types/MarketCode';

const getValuation = async (
  url: string,
  registrationNumber: string,
  mileage: number = 0,
  marketCode: MarketCode = 'SE',
  condition?: Condition
) => {
  const km = marketCode === 'SE' ? mileage * 10 : mileage * 10;
  const params = new URLSearchParams();
  params.set('regNo', registrationNumber);
  params.set('marketCode', marketCode);
  if (km) {
    params.set('km', km.toString());
  }
  if (condition) {
    params.set('condition', condition);
  }

  return await sendRequest<Valuation>({
    method: 'GET',
    url: `${url}/wip/external/vehicle?${params.toString()}`,
  });
};

export const getValuationErrorMessage = (status?: number) => {
  switch (status) {
    case 404:
      return i18next.t('error.valuation');
    default:
      return i18next.t('error.unspecific');
  }
};

export default getValuation;
